import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Typography from "@mui/material/Typography";
import { Stack } from "@mui/material";
const StatCard = (props) => {
    const { id, stat, statColor, title, description } = props;
    return (_jsxs(Stack, { direction: "column", spacing: 2, divider: _jsx(Divider, { sx: { borderColor: "#fff", mt: 0 } }), sx: {
            border: "1px solid",
            borderColor: "border.default",
            padding: "24px",
            height: "100%",
            boxSizing: "border-box",
            width: "100%",
        }, children: [_jsxs(Box, { children: [_jsx(Typography, { component: "span", sx: {
                            color: statColor || "primary.contrastText",
                            fontSize: { xs: "24px", md: "32px" },
                            fontWeight: 700,
                        }, children: stat }), title && (_jsx(Typography, { component: "span", sx: {
                            color: "primary.contrastText",
                            fontWeight: 700,
                            ml: 1,
                            fontSize: { xs: "16px", md: "22px" },
                        }, children: title }))] }), description && (_jsx(Typography, { variant: "body1", sx: {
                    fontWeight: 500,
                    color: "primary.contrastText",
                    height: { xs: "auto", md: "72px" },
                }, children: description }))] }, id));
};
export default StatCard;
